export default function () {
  const header = window.document.querySelector('.header');
  const headerContainer = window.document.querySelector('.header-container');
  const burgerButton = window.document.querySelector('.c-hamburger');
  const menuLink = window.document.querySelectorAll('.navp__menu-link');
  const headerLoft = window.document.querySelector('.header__loft');
  const scroll = [
    '.header',
    '.header__row',
    '.header__link',
    '.header__reserve-button',
    '.top-menu__link',
    '.c-logo',
    '.c-logo__item',
    '.c-hamburger',
    '.c-hamburger__item',
    '.navm__section--1',
    '.navm__section--2',
  ];
  let isSubmenuOpen = false;

  /**
   * headerStick
   * @return void
   */
  function headerStick() {
    scroll.forEach((item) => {
      const elements = window.document.querySelectorAll(item);
      elements.forEach((element) => {
        element.classList.add('inverse');
        element.classList.add('scroll');
      });
    });
    setTimeout(() => {
      header.classList.add('animate');
    }, 50);
  }

  if (document.body.classList.contains('corporate-blog')) {
    const toggleInverseClass = (addInverseClass) => {
      scroll.forEach((item) => {
        const elements = document.querySelectorAll(item);
        elements.forEach((element) => {
          if (addInverseClass) {
            element.classList.add('inverse');
          } else {
            element.classList.remove('inverse');
          }
        });
      });
    };

    headerContainer.addEventListener('mouseenter', () => {
      if (window.innerWidth > 768) {
        toggleInverseClass(true);
      }
    });

    headerContainer.addEventListener('mouseleave', () => {
      if (window.innerWidth > 768 && !burgerButton.classList.contains('open')) {
        toggleInverseClass(false);
      }
    });
  }

  /**
   * headerUnStick
   * @return void
   */
  function headerUnStick() {
    isSubmenuOpen = false;
    if (burgerButton.classList.contains('open')) {
      isSubmenuOpen = true;
    }
    menuLink.forEach((link) => {
      if (link.classList.contains('open')) {
        isSubmenuOpen = true;
      }
    });

    scroll.forEach((item) => {
      const elements = window.document.querySelectorAll(item);
      elements.forEach((element) => {
        element.classList.remove('scroll');
        if (isSubmenuOpen === false) {
          element.classList.remove('inverse');
        }
      });
    });

    header.classList.remove('animate');
  }

  /**
   * headerTrigger
   * @return void
   */
  function headerTrigger() {
    const st = window.pageYOffset;
    const { body: b } = window.document;
    const { offsetTop: ot } = b;
    const d = ot + st;
    const p = headerContainer.clientHeight;

    if (d > p) {
      headerStick();
    }

    if (d < p) {
      headerUnStick();
    }
  }

  /**
   * headerHeight
   * @return void
   */
  function headerContainerHeight(extra = 0) {
    headerContainer.removeAttribute('style');
    headerContainer.style.height = `${headerContainer.clientHeight + extra}px`;
  }

  window.addEventListener('load', () => {
    headerTrigger();
    headerContainerHeight();
  });

  window.addEventListener('scroll', () => {
    headerTrigger();
  });

  window.addEventListener('resize', () => {
    let loftHeight = 0;

    if (window.screen.width < 768 && header.classList.contains('scroll') && headerLoft !== null) {
      loftHeight = 35;
    }

    headerContainerHeight(loftHeight);
  });
}
